import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa6";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";

const FilterComponent = ({ fields, onApply, onReset, handleClose, onDistributorChange, onProductGroupChange }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState({});

  const handleFilterChange = (id, value) => {
    setFilters((prev) => {
      const newFilters = {
        ...prev,
        [id]: value,
      };
      
      // If distributor name changes, reset doctor name and notify parent
      if (id === "distributorName") {
        newFilters.doctorName = "";
        // Call the parent callback to fetch doctors immediately
        if (onDistributorChange) {
          onDistributorChange(value);
        }
      }
      // NEW: If product group changes, reset product name and notify parent
      if (id === "productGroup") {
        newFilters.productName = "";
        // Call the parent callback to fetch product names immediately
        if (onProductGroupChange) {
          onProductGroupChange(value);
        }
      }
      
      return newFilters;
    });
  };

  const handleApply = () => {
    console.log("items", filters);
    if (onApply) {
      onApply(filters);
    }
  };

  const handleReset = () => {
    setFilters({});
    onReset && onReset();
  };

  const renderField = (field) => {
    switch (field.type) {
      case "dropdown":
        return (
          <div key={field.id}>
            <label htmlFor={field.id} className="primary_label">
              {field.label}
            </label>
            <div className="primary-dropdown mt-1">
              <select
                id={field.id}
                name={field.id}
                value={filters[field.id] || ""}
                onChange={(e) => handleFilterChange(field.id, e.target.value)}
                className={`rounded px-1 text-sm font-normal w-full cursor-pointer focus:outline-none focus:ring-0 ${
                  filters[field.id] !== "" ? "text-text1" : "text-text3"
                }`}
                disabled={
                  (field.id === "doctorName" && !filters.distributorName) || // Disable doctor dropdown if no distributor selected
                  (field.id === "productName" && !filters.productGroup) // NEW: Disable product name dropdown if no product group selected
                }
              >
                <option value="" className="text-text3">
                  {field.id === "doctorName" && !filters.distributorName 
                    ? "Select Distributor First" 
                    : field.id === "productName" && !filters.productGroup
                    ? "Select Product Group First" // NEW: Show message for product name dropdown
                    : "Select"}
                </option>
                {field.options?.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    className="text-text1"
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );

      case "date":
        return (
          <div key={field.id}>
            <label htmlFor={field.id} className="primary_label">
              {field.label}
            </label>
            <div className="relative mt-1">
              <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                <HeroiconsOutlineCalendar className="text-md text-gray-500" />
              </div>
              <div className="pl-10">
                <input
                  type="date"
                  id={field.id}
                  name={field.id}
                  value={filters[field.id] || ""}
                  onChange={(e) => handleFilterChange(field.id, e.target.value)}
                  className="w-full custom-dateinput border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                />
              </div>
            </div>
          </div>
        );

      case "text":
        return (
          <div key={field.id}>
            <label htmlFor={field.id} className="primary_label">
              {field.label}
            </label>
            <input
              type="text"
              id={field.id}
              name={field.id}
              value={filters[field.id] || ""}
              onChange={(e) => handleFilterChange(field.id, e.target.value)}
              className="mt-1 w-full rounded px-2 py-1 text-sm font-normal text-text1 border focus:outline-none focus:ring-1 focus:ring-gray-300"
              placeholder={`Enter ${field.label.toLowerCase()}`}
            />
          </div>
        );

      default:
        return null;
    }
  };

  const Content = () => (
    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
      {fields.map(renderField)}
    </div>
  );

  return (
    <div>
      {/* Large Screen */}
      <div className="hidden sm:block">
        <div className="mt-4 p-4 bg-gray-100 rounded-md">
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center  focus:outline-none focus:ring-0">
              {openFilter ? (
                <button onClick={() => setOpenFilter(false)}>
                  <FaChevronDown />
                </button>
              ) : (
                <button onClick={() => setOpenFilter(true)}>
                  <FaChevronRight />
                </button>
              )}
              <h2 className="text-lg text-text1 font-bold">Filters</h2>
            </div>
            {openFilter && (
              <div className="flex justify-end space-x-2">
                <button
                  onClick={handleReset}
                  className="border rounded-md px-3 py-1 bg-white"
                >
                  Reset
                </button>
                <button
                  onClick={handleApply}
                  className="bg-primary text-white rounded-md px-3 py-1 hover:bg-primary"
                >
                  Apply
                </button>
              </div>
            )}
          </div>
          {openFilter && <Content />}
        </div>
      </div>

      {/* Mobile Screen */}
      <div className="sm:hidden">
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={handleClose}
        >
          <div
            className="bg-white px-6 py-8 rounded-3xl w-[90%] shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <div>
                <h2 className="text-2xl text-text1 font-bold">Filters</h2>
                <hr className="text-gray-200 mt-3" />
              </div>
              <Content />
              <div className="flex justify-end space-x-2">
                <button
                  onClick={handleReset}
                  className="border rounded-md px-3 py-1 bg-white"
                >
                  Reset
                </button>
                <button
                  onClick={handleApply}
                  className="bg-primary text-white rounded-md px-3 py-1 hover:bg-primary"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;